import React from 'react';
import Navbar from '../../Company/About/Navbar';
import WelcomeSection from './WelcomeSection';
import Footer from '../../Company/About/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';

export default function TestResults() {
    const candidate = {
        details: {
            strengths: "Strong problem-solving skills, Excellent communication",
            weaknesses: "Needs to improve time management, Lacks experience in advanced algorithms"
        }
    };
    return (
        <div className={cn("min-h-screen w-full bg-background flex flex-col")}>
            <Navbar />
            <WelcomeSection userName={"UserName"} />
            <div className={cn("flex w-full")}>
                <div className={cn(
                    "w-64 min-w-64 bg-[#050F47] text-white p-9",
                    "flex flex-col gap-4 shadow-md"
                )}>
                    <Heading level="h3" className="text-2xl font-bold mb-4">Other Results</Heading>
                    {[1, 2, 3, 4].map((i) => (
                        <Button
                            key={i}
                            variant="ghost"
                            className={cn(
                                "text-base font-normal text-white p-3.5 text-left",
                                "rounded-lg bg-[#050F47] hover:bg-[#03157d]",
                                "transition-all"
                            )}
                        >
                            23 May 2025, 10:40 am
                        </Button>
                    ))}
                </div>
                <div className={cn(
                    "flex flex-col items-center gap-8",
                    "w-full p-8"
                )}>
                    <Card className={cn("w-full max-w-4xl")}>
                        <CardContent className="p-8">
                            <Stack spacing="lg" align="center" className="text-center">
                                <Heading level="h1" className="text-3xl font-bold">Mock Interview Result</Heading>
                                <Stack spacing="xs">
                                    <Text><strong>Test Time</strong>: 23 May 2025 at 10:40 am</Text>
                                    <Text><strong>Time Taken</strong>: 30 min</Text>
                                </Stack>
                                <div className={cn("flex justify-center items-center gap-5 flex-wrap")}>
                                    {[
                                        { label: "Overall Score", value: "80%", bg: "rgba(52, 199, 125, 0.5)" },
                                        { label: "Domain Score", value: "80%", bg: "rgba(255, 165, 0, 0.5)" },
                                        { label: "Confidence Score", value: "80%", bg: "rgba(93, 82, 217, 0.25)" }
                                    ].map((score, i) => (
                                        <div key={i} className={cn("flex flex-col items-center justify-center p-2.5 gap-2.5 font-bold")}>
                                            <Text className="font-semibold">{score.label}</Text>
                                            <div className={cn("px-6 py-3 rounded-lg text-2xl")} style={{ backgroundColor: score.bg }}>
                                                {score.value}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Stack>
                        </CardContent>
                    </Card>
                    
                    <Card className={cn("w-full max-w-4xl hover:shadow-lg transition-shadow")}>
                        <CardContent className="p-5">
                            <Stack spacing="md">
                                <div>
                                    <Heading level="h2" className="text-xl font-semibold mb-3">Strengths:</Heading>
                                    <ul className={cn("list-disc list-inside space-y-1")}>
                                        {candidate.details.strengths
                                            ? candidate.details.strengths
                                                .replace(/[\[\]']+/g, "")
                                                .split(",")
                                                .slice(0, 2)
                                                .map((s, i) => <li key={i} className="text-base">{s.trim()}</li>)
                                            : <li className="text-base">No strengths listed</li>}
                                    </ul>
                                </div>
                                <Separator />
                                <div>
                                    <Heading level="h2" className="text-xl font-semibold mb-3">Weaknesses:</Heading>
                                    <ul className={cn("list-disc list-inside space-y-1")}>
                                        {candidate.details.weaknesses
                                            ? candidate.details.weaknesses
                                                .replace(/[\[\]']+/g, "")
                                                .split(",")
                                                .slice(0, 2)
                                                .map((w, i) => <li key={i} className="text-base">{w.trim()}</li>)
                                            : <li className="text-base">No weaknesses listed</li>}
                                    </ul>
                                </div>
                            </Stack>
                        </CardContent>
                    </Card>
                    <Card className={cn("w-full max-w-4xl hover:shadow-lg transition-shadow")}>
                        <CardContent className="p-5">
                            <Stack spacing="md">
                                <Heading level="h2" className="text-xl font-semibold">Feedback</Heading>
                                <Separator />
                                <Text>
                                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eius aspernatur animi esse laborum obcaecati id pariatur eos iste nam cum amet, facilis consequuntur dolorem quia similique sit deleniti maiores praesentium.
                                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Molestias dignissimos deserunt omnis, nobis odit repellendus commodi nisi, doloremque minima accusantium officiis illum quo consectetur, saepe maxime aspernatur corrupti voluptatibus ipsum!
                                </Text>
                            </Stack>
                        </CardContent>
                    </Card>
                    <div className={cn("w-full max-w-4xl")}>
                        <Text><strong>Note:</strong> Lorem ipsum dolor sit amet consectetur adipisicing elit. Est a fuga illum omnis laborum ab velit, illo quibusdam repellat nostrum mollitia, natus nobis minus facilis veniam perferendis dolorem nam molestias?</Text>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}